export default {"src":"/_next/static/media/idea.c55d8291.svg","height":37,"width":25,"blurWidth":0,"blurHeight":0};